<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="products">
      @for (product of products.controls; track product; let index = $index) {
        @if (index == 0) {
          <ng-container [formGroup]="product">
            <ng-container formGroupName="parameters">
              <div class="row">
                <div class="col col-md-6">
                  <pr-input-column label="Frais de notaire" [derrors]="derrors">
                    <input
                      formControlName="realEstateNotaryFees"
                      type="number"
                      fraction="2"
                    />
                    <i>€</i>
                  </pr-input-column>
                </div>
                <div class="col col-md-6">
                  <pr-input-column label="Frais de gestion" [derrors]="derrors">
                    <input
                      formControlName="realEstateAgencyFees"
                      type="number"
                      fraction="2"
                    />
                    <i>€</i>
                  </pr-input-column>
                </div>
              </div>
              <div class="row">
                <div class="col col-md-6">
                  <pr-input-column
                    label="Frais de co-propriété"
                    [derrors]="derrors"
                  >
                    <input
                      formControlName="realEstateCondoFees"
                      type="number"
                      fraction="2"
                    />
                    <i>€</i>
                  </pr-input-column>
                </div>
                <div class="col col-md-6">
                  <pr-input-column label="Taxe foncière" [derrors]="derrors">
                    <input
                      formControlName="realEstatePropertyTaxFees"
                      type="number"
                      fraction="2"
                    />
                    <i>€</i>
                  </pr-input-column>
                </div>
              </div>
            </ng-container>
          </ng-container>
        }
      }
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
